import appTypes from './appTypes.json'
import frameworks from './frameworks.json'
import repo from './repo.json'
import deployment from './deployment.json'

const asList = (obj) => Object.entries(obj).map(([key, value]) => {
	return { id: key, ...value }
})

const appTypesAsList = asList(appTypes);
const frameworksAsList = asList(frameworks);
const repoAsList = asList(repo);
const deploymentAsList = asList(deployment);

const getFrameworks = (selectedAppType) => {
	if (selectedAppType && selectedAppType !== '') {
		return frameworksAsList.filter(framework => framework.appTypes.includes(selectedAppType))
	}
	return frameworksAsList
}

export {
	appTypesAsList,
	frameworksAsList,
	repoAsList,
	deploymentAsList,
	getFrameworks
}
